function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import i18n from 'invision-core/src/components/i18n/i18n';
import CoreLocaleKeys from 'invision-core/src/locales/core.locale.keys';
import { CurrentCustomerIdSelector } from '../../../../reducers/selectors/customer.selectors';
import { fetchCodeTypes } from 'invision-core/src/components/metadata/codes/codes.actions';
import LocaleKeys from '../../../../locales/keys';
import { MetadataCodeLoadedSelector, MetadataOptionsForCodeValuesWithoutPlaceholderSelector } from 'invision-core/src/components/metadata/codes/codes.selectors';
import moment from 'moment';
import { updateServiceLifeCycleStatus } from '../../../../reducers/actions/update.service.life.cycle.status.actions';
var UpdateServiceLifeCycleStatusController = /*#__PURE__*/function () {
  function UpdateServiceLifeCycleStatusController($ngRedux, $timeout, uiNotificationService) {
    _classCallCheck(this, UpdateServiceLifeCycleStatusController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      $timeout: $timeout,
      LocaleKeys: LocaleKeys,
      CoreLocaleKeys: CoreLocaleKeys,
      uiNotificationService: uiNotificationService
    });
  }
  return _createClass(UpdateServiceLifeCycleStatusController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          currentCustomerId: CurrentCustomerIdSelector(store),
          isServiceLifeCycleStatusLoaded: MetadataCodeLoadedSelector(CODES.ServiceLifeCycleStatus, store),
          serviceLifeCycleStatus: MetadataOptionsForCodeValuesWithoutPlaceholderSelector(CODES.ServiceLifeCycleStatus, store)
        };
      };
      var controllerActions = {
        fetchCodeTypes: fetchCodeTypes,
        updateServiceLifeCycleStatus: updateServiceLifeCycleStatus
      };
      this.disconnect = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      if (!this.state.isServiceLifeCycleStatusLoaded) {
        this.actions.fetchCodeTypes(CODES.ServiceLifeCycleStatus);
      }
    }
  }, {
    key: "handleClose",
    value: function handleClose() {
      this.onClose()();
    }
  }, {
    key: "submitForm",
    value: function submitForm() {
      var _this2 = this;
      if (this.UpdateServiceLifeCycleStatus.$valid) {
        this.actions.updateServiceLifeCycleStatus(this.state.currentCustomerId, moment().toISOString(), this.lifecycleStatusSelected, this.reasonDescription, this.serviceIdentifier).then(function () {
          _this2.uiNotificationService.transientSuccess(i18n.translate(LocaleKeys.CUSTOMER_DASHBOARD.UPDATE_SERVICE_LIFE_CYCLE_STATUS.SUCCESS));
          _this2.handleClose();
        }).catch(function (error) {
          _this2.uiNotificationService.transientError(error.translatedMessage);
          _this2.handleClose();
        });
      }
    }
  }]);
}();
export default {
  template: require('./update.service.life.cycle.status.modal.html'),
  controller: UpdateServiceLifeCycleStatusController,
  bindings: {
    onClose: '&',
    onSubmit: '&',
    serviceIdentifier: '<'
  }
};